'use strict'

const variantChangeEvent = {
    emitEvent (data) {
        const event = new CustomEvent('variantChange', {
            detail: data
        });

        window.dispatchEvent(event);
    }
}

export default variantChangeEvent;